import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "info" }
const _hoisted_5 = { class: "info" }
const _hoisted_6 = {
  key: 0,
  class: "info"
}

import { Viewer } from "@bytemd/vue-next";

import { PostVO } from "../generated";
import gfm from "@bytemd/plugin-gfm";
import highlight from "@bytemd/plugin-highlight-ssr";
import math from "@bytemd/plugin-math-ssr";
import moment from "moment";
import { useStore } from "vuex";

interface Props {
  post: PostVO;
}

/**
 给组件指定初始值
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'CommentCard',
  props: {
    post: { default: () => ({} as PostVO) }
  },
  setup(__props: any) {

const store = useStore();

/**
 定义组件属性类型
 */
const props = __props;
const plugins = [
  gfm(),
  highlight(),
  math(),
  // Add more plugins here
];

return (_ctx: any,_cache: any) => {
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { class: "card" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_row, { style: {"align-items":"center"} }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { span: 8 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_avatar, { size: 100 }, {
                default: _withCtx(() => [
                  (_ctx.post.user?.userAvatar !== '')
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        alt: "avatar",
                        src: _ctx.post.user?.userAvatar
                      }, null, 8, _hoisted_1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.post.user?.userName), 1))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, { span: 16 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, "评论作者：" + _toDisplayString(_ctx.post.user?.userName), 1),
              _createElementVNode("div", _hoisted_4, " 评论时间：" + _toDisplayString(_unref(moment)(_ctx.post.createTime).format("YYYY-MM-DD HH:mm:ss")), 1),
              _createElementVNode("div", _hoisted_5, " 发布时间：" + _toDisplayString(_unref(moment)(_ctx.post.updateTime).format("YYYY-MM-DD HH:mm:ss")), 1),
              (_unref(store).state.user?.loginUser?.userRole === 'admin')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(Viewer), {
        plugins: plugins,
        value: _ctx.post.content
      }, null, 8, ["value"])
    ]),
    _: 1
  }))
}
}

})